import { Link, useLocation } from 'react-router-dom';
import {
  Building2,
  Dumbbell,
  Earth,
  Home,
  Mail,
  Trophy,
  PiggyBank,
  HandCoins,
  Users,
  Boxes,
  BadgeDollarSign
} from 'lucide-react';

import { Button } from '@/components/ui/button';

import CoachNotificationDot from './addSidebar/CoachNotificationDot';

const AppSidebar = () => {
  const location = useLocation();

  return (
    <div className="h-full fixed left-0 top-0 bottom-0 w-[var(--sidebar-width)] border-r px-4 pt-[var(--sidebar-padding-top)] bg-background">
      <div className="flex flex-col gap-2">
        <Button
          className="w-full justify-start"
          variant={
            location.pathname.startsWith('/home') ? 'secondary' : 'ghost'
          }
          asChild
        >
          <Link component={Link} to="/home">
            <Home />
            Home
          </Link>
        </Button>
        <Button
          className="w-full justify-start"
          variant={
            location.pathname.startsWith('/tenant') ? 'secondary' : 'ghost'
          }
          asChild
        >
          <Link component={Link} to="/tenant">
            <Building2 />
            Tenants
          </Link>
        </Button>
        <Button
          className="w-full justify-start"
          variant={
            location.pathname.startsWith('/order') ? 'secondary' : 'ghost'
          }
          asChild
        >
          <Link component={Link} to="/order">
            <BadgeDollarSign />
            Orders
          </Link>
        </Button>
        <Button
          className="w-full justify-start"
          variant={
            location.pathname.startsWith('/user') ? 'secondary' : 'ghost'
          }
          asChild
        >
          <Link component={Link} to="/user">
            <Users />
            Users
          </Link>
        </Button>
        <Button
          className="w-full justify-start"
          variant={
            location.pathname.startsWith('/coach') ? 'secondary' : 'ghost'
          }
          asChild
        >
          <Link component={Link} to="/coach">
            <CoachNotificationDot />
            <Trophy />
            Coaches
          </Link>
        </Button>
        <Button
          className="w-full justify-start"
          variant={
            location.pathname.startsWith('/region') ? 'secondary' : 'ghost'
          }
          asChild
        >
          <Link component={Link} to="/region">
            <Earth />
            Regions
          </Link>
        </Button>
        <Button
          className="w-full justify-start"
          variant={
            location.pathname.startsWith('/activity') ? 'secondary' : 'ghost'
          }
          asChild
        >
          <Link component={Link} to="/activity">
            <Dumbbell />
            Activities
          </Link>
        </Button>
        <Button
          className="w-full justify-start"
          variant={location.pathname.startsWith('/fee') ? 'secondary' : 'ghost'}
          asChild
        >
          <Link component={Link} to="/fee">
            <PiggyBank />
            Fees
          </Link>
        </Button>
        <Button
          className="w-full justify-start"
          variant={location.pathname.startsWith('/tax') ? 'secondary' : 'ghost'}
          asChild
        >
          <Link component={Link} to="/tax">
            <HandCoins />
            Taxes
          </Link>
        </Button>{' '}
        <Button
          className="w-full justify-start"
          variant={
            location.pathname.startsWith('/offering-category')
              ? 'secondary'
              : 'ghost'
          }
          asChild
        >
          <Link component={Link} to="/offering-category">
            <Boxes />
            Offering Categories
          </Link>
        </Button>
        <Button
          className="w-full justify-start"
          variant={
            location.pathname.startsWith('/sales-site-leads')
              ? 'secondary'
              : 'ghost'
          }
          asChild
        >
          <Link component={Link} to="/sales-site-leads">
            <Mail />
            Sales Site Leads
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default AppSidebar;
